"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.storeTrafficSource = exports.getTrackingQueryString = exports.getInternalTrafficSource = exports.getDataLayer = exports.getAnalyticsId = exports.getAnalyticsDataAttributes = void 0;

var _deepmerge = _interopRequireDefault(require("deepmerge"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

var cleanText = function cleanText(text) {
  return typeof text === "string" ? text.trim().toLowerCase().replace(/[^a-z\d- ]/gi, "").replace(/\s+/g, "-") : text;
};

var flattenData = function flattenData(data, prefix, result) {
  prefix = prefix || "";
  result = result || {};

  for (var key in data) {
    var lowerCaseKey = key.toLowerCase();

    if (_typeof(data[key]) !== "object" || data[key] instanceof Array) {
      result[prefix + lowerCaseKey] = data[key];
    } else {
      flattenData(data[key], prefix + lowerCaseKey + "_", result);
    }
  }

  return result;
};

var getAnalyticsDataAttributes = function getAnalyticsDataAttributes(analyticsData) {
  var dataAttributes = {};

  for (var key in analyticsData) {
    dataAttributes["data-analytics-".concat(key)] = String(analyticsData[key]);
  }

  return dataAttributes;
};

exports.getAnalyticsDataAttributes = getAnalyticsDataAttributes;

var getAnalyticsId = function getAnalyticsId(data, applyRules) {
  var _applyRules = applyRules(data),
      pageData = _applyRules.pageData,
      eventData = _applyRules.eventData;

  if (pageData && pageData.page && eventData && eventData.event) {
    var _pageData$page = pageData.page,
        siteSection = _pageData$page.siteSection,
        siteSubSection = _pageData$page.siteSubSection,
        pageTitle = _pageData$page.pageTitle;
    var _eventData$event = eventData.event,
        label = _eventData$event.label,
        location = _eventData$event.location;
    return [siteSection, siteSubSection, pageTitle, label, location].filter(Boolean).map(cleanText).join(":");
  }

  return null;
};

exports.getAnalyticsId = getAnalyticsId;

var getDataLayer = function getDataLayer(data, applyRules) {
  var _applyRules2 = applyRules(data),
      siteData = _applyRules2.siteData,
      pageData = _applyRules2.pageData,
      eventData = _applyRules2.eventData;

  try {
    // Add internal traffic source
    var gemid2 = localStorage.getItem("gemid2");

    if (gemid2 !== null) {
      pageData.trafficSource = {
        internalSource: gemid2
      };
      localStorage.removeItem("gemid2");
    }
  } catch (e) {} // Handles following exception thrown from incognito iframe, ok with no debugging
  // DOMException: Failed to read the 'localStorage' property from 'Window': Access is denied for this document.
  // Merge and flatten


  var mergedData = _deepmerge["default"].all([siteData, pageData, eventData].filter(Boolean), {
    // Override the existing array values completely rather than concatenating them
    arrayMerge: function arrayMerge(_destinationArray, sourceArray) {
      return sourceArray;
    }
  });

  return flattenData(mergedData);
};

exports.getDataLayer = getDataLayer;

var getInternalTrafficSource = function getInternalTrafficSource(_ref) {
  var pageData = _ref.pageData,
      eventData = _ref.eventData,
      siteData = _ref.siteData;

  if (pageData && pageData.page && eventData && eventData.event) {
    var _pageData$page2 = pageData.page,
        siteSection = _pageData$page2.siteSection,
        pageTitle = _pageData$page2.pageTitle;
    var _eventData$event2 = eventData.event,
        label = _eventData$event2.label,
        location = _eventData$event2.location;
    var site = siteData && siteData.page && siteData.page.site;
    return [site, siteSection, pageTitle, label, location].filter(Boolean).map(cleanText).join(":");
  }

  return null;
};

exports.getInternalTrafficSource = getInternalTrafficSource;

var getTrackingQueryString = function getTrackingQueryString(data, applyRules) {
  var gemid2 = getInternalTrafficSource(applyRules(data));
  return gemid2 === null ? "" : "?gemid2=".concat(encodeURIComponent(gemid2));
};

exports.getTrackingQueryString = getTrackingQueryString;

var storeTrafficSource = function storeTrafficSource(data, applyRules) {
  var gemid2 = getInternalTrafficSource(applyRules(data));

  if (gemid2 !== null) {
    localStorage.setItem("gemid2", gemid2);
  }
};

exports.storeTrafficSource = storeTrafficSource;